import { render } from "./NewCaptionComponent.vue?vue&type=template&id=371026ee&scoped=true"
import script from "./NewCaptionComponent.vue?vue&type=script&lang=js"
export * from "./NewCaptionComponent.vue?vue&type=script&lang=js"

import "./NewCaptionComponent.vue?vue&type=style&index=0&id=371026ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371026ee"]])

export default __exports__